import { Box, LinearProgress, Typography } from '@mui/material';
import React from 'react';

interface Props {
  currentProgress: number;
  maxProgress: number;
}

export const ProgressIndicator: React.FC<Props> = ({ currentProgress, maxProgress }) => {
  const progressPercentage = (currentProgress / maxProgress) * 100;

  return (
    <Box sx={{ my: 2, width: '100%' }}>
      <Box sx={{ alignItems: 'center', display: 'flex', mb: 1 }}>
        <Box sx={{ flexGrow: 1, mr: 1, width: '100%' }}>
          <LinearProgress
            sx={{
              '& .MuiLinearProgress-bar': {
                backgroundColor: 'var(--bs-primary)',
                borderRadius: 5,
              },
              backgroundColor: '#e0e0e0',
              borderRadius: 5,
              height: 8,
            }}
            value={progressPercentage}
            variant="determinate"
          />
        </Box>
        <Box sx={{ minWidth: 50 }}>
          <Typography
            className="text-primary small text-nowrap"
            color="text.secondary"
            // Line height of Boosted's .small (16px at 14px), which loses to MUI's body2 in the cascade layers
            sx={{ lineHeight: 16 / 14 }}
            variant="body2"
          >
            {currentProgress}/{maxProgress}{' '}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
